module.exports = __webpack_public_path__ + "img/laravel.7aef0026.png";